import React from 'react'
import styled from '~/design/styled'
import { Spinner } from '@hermes/design-system'

export const ScreenLoader = () => {
  return (
    <ScreenLoaderStyled>
      <Spinner size={64} width={3} />
    </ScreenLoaderStyled>
  )
}

const ScreenLoaderStyled = styled.div({
  display: 'flex',
  minHeight: '60vh',
  justifyContent: 'center',
  alignItems: 'center',
})
